<template>
    <el-dialog :visible.sync="showDialog" width="400px" @close="closePage">
        <template>
            <div>
                <p>{{$t('masters.pleaseEnterTheNotification')}}</p>
                <textarea v-model="message" :notificationMessage.sync="notificationMessage" style="width:355px; max-width:355px"></textarea>
                <br />
                <el-button type="primary" @click="addNotification">{{$t('common.ok')}}</el-button>
                <el-button @click="closePage">{{$t('common.cancel')}}</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
    import Vue from "vue";
    import api from "../api";
    export default {
        name: "promptDialog",
        props: {
            visible: {
                type: Boolean,
                default: false,

            },
            notificationMessage: {
                type: String
            }
        },
  data() {
    return {
        showDialog: this.visible,
        message: this.notificationMessage,

    }
        },
        watch: {
            visible: function (val)
            {
                this.showDialog = val;
            },
            notificationMessage: function (val)
            {
                this.message = val
            }

        },
        methods: {
            closePage()
            {
                this.showDialog = false;
                this.$emit("promptDialogClosed", false);

                if (!this.notificationMessage)
                {
                    this.message = '';
                }
            },
            addNotification()
            {
                if (!this.message.trim())
                {
                    this.closePage();
                }
                else
                {
                    this.$emit("notification", this.message);
                    this.showDialog = false;
                    this.$emit("promptDialogClosed", false);
                    if (!this.notificationMessage)
                    {
                        this.message = '';
                    }

                }

            },

        }

}
</script>




// WEBPACK FOOTER //
// ClientApp/app/masters/customers/components/PromptDialog.vue